import PageHeader from "../components/PageHeader";
import QuoteForm from "../components/QuoteForm";
import { useLang } from "../i18n/LanguageContext";

export default function QuotePage() {
  const { t } = useLang();
  return (
    <>
      <PageHeader
        overline={t("pages.quoteOverline")}
        title={<>{t("pages.quoteTitlePre")} <span className="italic text-[#1E3A5F]">{t("pages.quoteTitleItalic")}</span>.</>}
        subtitle={t("pages.quoteSubtitle")}
      />
      <QuoteForm />
    </>
  );
}
